/* @ngInject */
function brandBaseService ($rootScope, AssetService, ConnectorWebService, CONSTANTS, Utils) {
  const MAX_FILE_SIZE = 31457280 // 30mb
  const MAX_IMAGES_FILES = 50
  const service = {
    getBrandSections,
    getBrandSectionCategories,
    getBrandSectionAssets,
    isValidImageFileSize,
    isInvalidImageFileLength
  }
  return angular.extend({}, AssetService, service)

  function getBrandSections () {
    return ConnectorWebService.get(CONSTANTS.URL_BRAND_SECTIONS)
  }

  function getBrandSectionCategories (brandSectionId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_ID_CATEGORIES, [brandSectionId])
    return ConnectorWebService.get(url)
  }

  function isValidImageFileSize (assets) {
    const MAX_UPLOAD_SIZE = $rootScope.oUserCompanyConfigurations.MAX_BRAND_UPLOAD_SIZE

    if (MAX_UPLOAD_SIZE) {
      return assets.every(asset => asset.size <= MAX_UPLOAD_SIZE)
    }

    return assets.every(asset => asset.size <= MAX_FILE_SIZE)
  }

  function isInvalidImageFileLength (images) {
    const MAX_IMPORT_IMAGES_FILES = $rootScope.oUserCompanyConfigurations.MAX_IMPORT_IMAGES_FILES

    if (MAX_IMPORT_IMAGES_FILES) {
      return images.length > MAX_IMPORT_IMAGES_FILES
    }

    return images.length > MAX_IMAGES_FILES
  }

  /**
  * Get assets from brand section
  * @param {Object} options
  * @param {number} options.sectionId - brand section id
  * @param {number} options.brandSectionCategoryId - brand section category id
  * @param {boolean} options.all - Should bring all assets, with or without category
  * @param {string} options.search - Search term to find assets
  * @param {number} options.top - pagination
  * @param {number} options.skip - pagination
  */
  function getBrandSectionAssets (options) {
    var url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRAND_SECTIONS_ID_ASSETS, [options.sectionId])
    url = Utils.fnAddTopSkipQueriesToUrl(url, options.top, options.skip)

    if (options.brandSectionCategoryId || options.all || options.search) {
      url = Utils.fnAddQueryToUrl(url, { brandSectionCategoryId: options.brandSectionCategoryId, all: options.all, search: options.search })
    }

    return ConnectorWebService.get(url).then(AssetService.mapGetResponse)
  }
}

export { brandBaseService }
